import { AdminMentorViewServices } from './service';

import {
    VIEW_STARTUP_APPLICATION_DATA,
   
} from '../../../../../common/constants/actionConstants';




import { isLoading } from '../../../../../common/dependencies/action/action';


export  const getViewApplicationData = (params) => dispatch => {
    dispatch(isLoading(true))
    return getBindData(params).then((data) => {
        //
        const { getViewApplicationData} = data;
        if (getViewApplicationData) {
            dispatch({
                type: VIEW_STARTUP_APPLICATION_DATA,
                payload: getViewApplicationData
            })
        }
        dispatch(isLoading(false))
    })
}



async function getBindData(params) {
    const getViewApplicationData = await AdminMentorViewServices.getViewApplicationData(params).catch(e => { return { data: [], status: false } });
  return { getViewApplicationData}
}

